import React from "react";
import { RouteProp } from "@react-navigation/core";
import { StackNavigationProp } from "@react-navigation/stack";

import { TodoEditParamList } from "./paramList";
import { UserLoggedInNavigatorParamList } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { useTheme } from "arkh";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";

import { TodoEditNewMain } from "./TodoEditNewMain/TodoEditNewMain";

import { StoreBanner } from "../../components/OrgHeaders/StoreBanner";
import { TimeZoneProvider } from "../../OS/Timezone";
import { TodoEditLinkProduct } from "./TodoEditLinkProduct";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";

const Navigator = createNativeStackNavigator<TodoEditParamList>();

export const TodoEdit = withWebModal(
  (props: {
    navigation: StackNavigationProp<UserLoggedInNavigatorParamList, "TodoEdit">;
    route: RouteProp<UserLoggedInNavigatorParamList, "TodoEdit">;
  }) => {
    const theme = useTheme();

    const intl_tokens = useIntlTokens();

    const getOptions = useNavigationHeaderOptions();

    return (
      <TimeZoneProvider timezone={props.route.params.storeTimezone}>
        {props.route.params.storeName ? (
          <StoreBanner storeName={props.route.params.storeName} />
        ) : null}
        <Navigator.Navigator
          key="EDIT_TODO_NAVIGATOR"
          screenOptions={{
            headerStyle: {
              backgroundColor: theme.background,
            },
          }}
        >
          <Navigator.Screen
            name="Main"
            initialParams={{
              id: props.route.params.todoId,

              autofocusResponse: props.route.params.autofocusResponse,
            }}
            component={TodoEditNewMain}
            options={({ navigation }) => ({
              ...getOptions({
                type: "DONE",
                onDone() {
                  navigation.goBack();
                },
                title: "",
              }),
            })}
          />
          <Navigator.Screen
            name="TodoEditLinkProduct"
            component={TodoEditLinkProduct}
            options={({ navigation }) => ({
              ...getOptions({
                type: "CLOSE",
                onClose() {
                  navigation.goBack();
                },
                title: intl_tokens.Products,
              }),
              presentation: "modal",
            })}
          />
        </Navigator.Navigator>
      </TimeZoneProvider>
    );
  },
  true
);
